import { TAddressCadastreValue } from '../types';
import { ADDRESS_CADASTRE_VALIDATION_ERRORS, CADASTRE_INPUT_VALUE_REGEXP } from '../const';

/**
 * Валидирует на клиенте обьект значения поля
 */
export function addressCadastreValidator(value: TAddressCadastreValue): string | void {
  // проверяем на пустое значение
  if (!value) {
    return ADDRESS_CADASTRE_VALIDATION_ERRORS.emptyValue;
  }

  // проверяем кадастровый номер на соответствие маске
  if (!value.address && !CADASTRE_INPUT_VALUE_REGEXP.test(value.cadastre as string)) {
    return ADDRESS_CADASTRE_VALIDATION_ERRORS.cadastreFormat;
  }
}
